import request from '@/util/request'

export function login(data) {
  return request({
    url: '/user/login',
    method: 'post',
    data
  })
}

export function checkToken() {
  return request({
    url: '/user/checkToken',
    method: 'post',
  })
}

export function loginStatus() {
  return request({
    url: '/user/loginStatus',
    method: 'get',
  })
}

/* 获取用户信息的接口 */
// export function getInfo() {
//   return request({
//     url: '/user/profile',
//     method: 'post'
//   })
// }

// 登出
export function logout() {
  return request({
    url: '/user/logOut',
    method: 'post'
  })
}
